<template>
  <div>
    <RegistrationLayout>
      <GMBLocations
        v-if="!loading"
        :max-location-count="maxLocationCount"
        :brand-name="brand.name"
        :business-groups="businessGroupsCollection"
        :show-gmb-oauth-link="true"
        @on-back="onBack"
        @submit-success="submitSuccess"
      />
      <Loading v-else />
    </RegistrationLayout>
  </div>
</template>

<script>
import {mapActions, mapState} from 'vuex'
import GMBLocations from '../components/GMBLocations'
import Loading from '../components/Loading'
import RegistrationLayout from '../layouts/RegistrationLayout'

export default {
  name: 'RegistrationsBrandsLocations',
  components: {
    GMBLocations,
    Loading,
    RegistrationLayout,
  },
  data() {
    return {
      selectedBusinessGroupId: null
    }
  },
  computed: {
    ...mapState({
      loading: state => state.companiesRegistrationsBrand.loading || state.companiesGmbAccounts.loading || state.companiesAvailablePlan.loading,
      brand: state => state.companiesRegistrationsBrand.brand,
      businessGroups: state => state.companiesGmbAccounts.data,
      availablePlan: state => state.companiesAvailablePlan,
    }),
    currentCompanyUuid: function () {
      return this.$route.params.company_uuid
    },
    maxLocationCount() {
      return this.availablePlan.data.attributes.max_store_count
    },
    businessGroupsCollection() {
      const obj = {}
      this.businessGroups.data.forEach(v => {
        obj[v.attributes.name] = v.id
      })
      return obj
    },
  },
  created() {
    this.readBusinessGroups(this.currentCompanyUuid)
    this.readBrand(this.currentCompanyUuid)
    this.readAvailablePlan(this.currentCompanyUuid)
  },
  methods: {
    ...mapActions({
      readBusinessGroups: 'companiesGmbAccounts/readCompaniesGmbAccounts',
      readBrand: 'companiesRegistrationsBrand/readRegistrationsBrand',
      readAvailablePlan: 'companiesAvailablePlan/readAvailablePlan',
      writeProgress: 'companiesRegistrationsProgresses/writeCompaniesRegistrationsProgresses',
    }),
    async submitSuccess() {
      const isSuccess = await this.writeProgress({
        companyUuid: this.currentCompanyUuid,
        kind: 10
      })
      if (isSuccess) this.$router.push(`/s/companies/${this.currentCompanyUuid}/registrations/completed`)
    },
    onBack() {
      // 登録選択が出来るようになったらこっちに切り替え
      // this.$router.push(`/s/companies/${this.currentCompanyUuid}/registrations/select`)
      this.$router.push(`/s/companies/${this.currentCompanyUuid}/registrations/business_groups`)
    },
  }
}
</script>
